import * as React from 'react';
import * as styled from './styled';
import {TaskObject} from 'api/task/types';
import {useBlockContext} from '../../hooks/useBlockContext';
import InputNumber from 'components/InputNumber';
import {useFormikContext} from 'formik';

/**
 * The score of the block.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Score(): React.ReactElement {
  const block = useBlockContext();
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();

  /**
   * Render input.
   * @return {JSX.Element}
   */
  function renderInput(): JSX.Element {
    /**
     * The change event handler.
     * @param {number} count
     */
    function handleChange(count: number): void {
      setFieldValue(
        `content.blocks[${block.index}].score`,
        count,
      );
    }

    return (
      <InputNumber
        minLength={0}
        maxLength={100}
        defaultValue={block.score}
        onChange={handleChange}
      />
    );
  }

  return (
    <styled.Wrapper>
      {renderInput()}
      баллов за правильный ответ
    </styled.Wrapper>
  );
}
